<script lang="ts">
import { Toaster } from '$lib/components/ui/sonner';
</script>

<Toaster position="bottom-center" />
